/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitagain2Inputs */

const en_coverfitagain2 = /** @type {(inputs: Coverfitagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust again`)
};

const de_coverfitagain2 = /** @type {(inputs: Coverfitagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nochmal anpassen`)
};

/**
* | output |
* | --- |
* | "Adjust again" |
*
* @param {Coverfitagain2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitagain2 = /** @type {((inputs?: Coverfitagain2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitagain2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitagain2(inputs)
	return de_coverfitagain2(inputs)
});
export { coverfitagain2 as "coverFitAgain" }